import { useTranslation } from 'react-i18next';

import { createFileRoute } from '@tanstack/react-router';

import { AccessDeniedView } from '@/components/AccessDenied';
import { PmDashboardOrchestrator } from '@/modules/Dashboard';
import { getAllowedDashboardVariants } from '@/modules/Dashboard/useDashboardVariant';
import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const Route = createFileRoute('/app/dashboard/pm')({
  component: PmDashboardRoute,
});

function PmDashboardRoute() {
  const { t } = useTranslation('dashboard');
  const { userData } = useAuth();

  if (!getAllowedDashboardVariants(userData?.role, userData?.company.status).includes('pm')) {
    return (
      <AccessDeniedView
        title={t('access_denied.title')}
        description={t('access_denied.description')}
        backHref="/app/dashboard"
        backLabel={t('access_denied.back_to_dashboard')}
      />
    );
  }

  return <PmDashboardOrchestrator />;
}
